import { Button, HStack, Text } from '@chakra-ui/react'

interface PublishActionsProps {
  selectedCount: number
  isPublishingSelected?: boolean
  isPublishingAll?: boolean
  onPublishSelected: () => void
  onPublishAll: () => void
}

export function PublishActions({
  selectedCount,
  isPublishingSelected = false,
  isPublishingAll = false,
  onPublishSelected,
  onPublishAll,
}: PublishActionsProps) {
  return (
    <HStack justify="space-between" width="100%">
      <Text color="fg.muted">
        {selectedCount === 0
          ? 'No SIBs selected'
          : `${selectedCount} SIB${selectedCount > 1 ? 's' : ''} selected`}
      </Text>

      <HStack>
        <Button
          variant="outline"
          onClick={onPublishSelected}
          disabled={selectedCount === 0}
          loading={isPublishingSelected}
        >
          Publish to Selected
        </Button>

        <Button colorPalette="blue" onClick={onPublishAll} loading={isPublishingAll}>
          Publish to All Matching SIBs
        </Button>
      </HStack>
    </HStack>
  )
}
